import moment from "moment";

const GROUP_LABELS = {
  ru: {
    today: "Сегодня",
    yesterday: "Вчера",
    thisWeek: "На этой неделе",
    earlier: "Ранее",
  },
  kk: {
    today: "Бүгін",
    yesterday: "Кеше",
    thisWeek: "Осы аптада",
    earlier: "Бұрын",
  },
};

function pickBucket(date, now) {
  const m = moment(date);
  if (m.isSame(now, "day")) return "today";
  if (m.isSame(now.clone().subtract(1, "day"), "day")) return "yesterday";
  if (m.isAfter(now.clone().subtract(7, "day"))) return "thisWeek";
  return "earlier";
}

/**
 * Groups notifications by relative date bucket.
 * Preserves input order within each bucket (caller is responsible for sorting).
 *
 * @param {import('../model/types').Notification[]} items
 * @param {string} [locale="ru"]
 * @returns {{ key: string, label: string, items: import('../model/types').Notification[] }[]}
 */
export function groupByDate(items, locale = "ru") {
  if (!Array.isArray(items) || items.length === 0) return [];
  const labels = GROUP_LABELS[locale === "kk" ? "kk" : "ru"];
  const now = moment();
  const order = ["today", "yesterday", "thisWeek", "earlier"];
  const buckets = { today: [], yesterday: [], thisWeek: [], earlier: [] };

  for (const item of items) {
    const key = pickBucket(item.created_at, now);
    buckets[key].push(item);
  }

  return order
    .filter((key) => buckets[key].length > 0)
    .map((key) => ({ key, label: labels[key], items: buckets[key] }));
}
